// Used only if payment/pricing-catalog is unreachable or returns an empty
// catalog, so the UI still has something to render. A single pricing range
// covering the whole device/technician span mimics the shape of a real
// catalog response closely enough for the client-side math in
// pricingMath.js to run unmodified. RA only ships Standard/Professional (no
// Enterprise tier); every other product ships all three.

export const EM_FALLBACK_PRICING_CATALOG = {
  orgCurrencyCode: "USD",
  devicePricingByEdition: [
    {
      editionName: "Standard",
      plans: [
        { planId: -1001, planName: "Standard Monthly", period: "Monthly" },
        { planId: -1002, planName: "Standard Annually", period: "Annually" },
      ],
      pricingRanges: [
        { minDevices: 0, maxDevices: 10000, monthlyUnitPrice: 0.99, yearlyUnitPrice: 9.9 },
      ],
    },
    {
      editionName: "Professional",
      plans: [
        { planId: -1003, planName: "Professional Monthly", period: "Monthly" },
        { planId: -1004, planName: "Professional Annually", period: "Annually" },
      ],
      pricingRanges: [
        { minDevices: 0, maxDevices: 10000, monthlyUnitPrice: 1.49, yearlyUnitPrice: 14.9 },
      ],
    },
    {
      editionName: "Enterprise",
      plans: [
        { planId: -1005, planName: "Enterprise Monthly", period: "Monthly" },
        { planId: -1006, planName: "Enterprise Annually", period: "Annually" },
      ],
      pricingRanges: [
        { minDevices: 0, maxDevices: 10000, monthlyUnitPrice: 1.99, yearlyUnitPrice: 19.9 },
      ],
    },
  ],
  technicianPricing: [
    { minTechnician: 1, maxTechnician: 50, monthlyUnitPrice: 10, yearlyUnitPrice: 100 },
  ],
  currencies: [
    { targetCurrencyCode: "EUR", conversionRate: 0.92 },
    { targetCurrencyCode: "GBP", conversionRate: 0.79 },
    { targetCurrencyCode: "INR", conversionRate: 83.1 },
    { targetCurrencyCode: "AUD", conversionRate: 1.52 },
    { targetCurrencyCode: "CAD", conversionRate: 1.36 },
    { targetCurrencyCode: "AED", conversionRate: 3.67 },
    { targetCurrencyCode: "SGD", conversionRate: 1.34 },
    { targetCurrencyCode: "JPY", conversionRate: 157 },
    { targetCurrencyCode: "SAR", conversionRate: 3.75 },
  ],
  addons: [
    {
      addonId: 1,
      addonName: "Additional Storage",
      pricingModel: "UNIT_PRICE",
      monthlyUnitPrice: 0.8,
      yearlyUnitPrice: 8,
    },
    {
      addonId: 2,
      addonName: "Premium Support",
      pricingModel: "PERCENTAGE",
      percentage: 20,
      basis: "endpoint",
    },
  ],
};

export const RA_FALLBACK_PRICING_CATALOG = {
  ...EM_FALLBACK_PRICING_CATALOG,
  devicePricingByEdition: EM_FALLBACK_PRICING_CATALOG.devicePricingByEdition.filter(
    (e) => e.editionName !== "Enterprise",
  ),
};

export const getFallbackPricingCatalog = (isRA) =>
  isRA ? RA_FALLBACK_PRICING_CATALOG : EM_FALLBACK_PRICING_CATALOG;